module.exports = __webpack_public_path__ + "static/media/SVID_S_4-1.b0f7ba5a.png";